var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther20(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 25.5C18.24 25.5 18 24.2101 18 23.9999H15C15 25.3801 15.99 27.8249 19.4999 28.38V30H22.5V28.38C25.5 27.8699 27 25.9349 27 23.9999C27 22.3201 26.22 19.4999 21 19.4999C18 19.4999 18 18.555 18 18C18 17.445 19.05 16.5 21 16.5C22.95 16.5 23.085 17.46 23.0999 18H26.1C26.0798 16.9781 25.7122 15.9936 25.0578 15.2084C24.4036 14.4233 23.5015 13.8842 22.5 13.68V12H19.4999V13.635C16.5 14.13 15 16.065 15 18C15 19.6799 15.78 22.5001 21 22.5001C23.9999 22.5001 23.9999 23.52 23.9999 23.9999C23.9999 24.4801 23.07 25.5 21 25.5Z",
    fill: "url(#paint0_linear_1246_8352)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.00049H6V9.00048H9.00001V34.5005C9.00001 34.8983 9.15803 35.2798 9.43934 35.5611C9.72065 35.8425 10.1022 36.0004 10.5 36.0004H31.5C31.8978 36.0004 32.2794 35.8425 32.5607 35.5611C32.842 35.2798 32.9999 34.8983 32.9999 34.5005V9.00048H36V6.00049H10.5ZM30 33.0005H12V9.00048H30V33.0005Z",
    fill: "url(#paint1_linear_1246_8352)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1246_8352",
    x1: 21,
    y1: 12,
    x2: 21,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63363A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1246_8352",
    x1: 21,
    y1: 6.00049,
    x2: 21,
    y2: 36.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63363A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther20);
export default __webpack_public_path__ + "static/media/Other2.0.530634b8109abc9d3a98f392aaf69125.svg";
export { ForwardRef as ReactComponent };